import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { WebSocketMetric } from "@/model/data/networkMetrics/WebSocketMetric";

export class GetInstallationNetworkMetricsResData extends ApiGenericResponse {
    metrics: Array<WebSocketMetric> = null;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.Metrics) {
            this.metrics = new Array<WebSocketMetric>();
            obj.Metrics.forEach((metric) => {
                let wsMetric = new WebSocketMetric();
                wsMetric.parse(metric);
                this.metrics.push(wsMetric);
            });
        }
    }
}
